import * as configcat from '@configcat/sdk';
import { environment } from '@deltager/organizers/admin/environments/environment';
import { isNullOrUndefined } from '../../shared/utils/object.utils';
import { from, map, Observable } from 'rxjs';

export class ConfigCatService {
  private static _client: configcat.IConfigCatClient;

  public static init(): void {
    if (!ConfigCatService._client) {
      ConfigCatService._client = configcat.getClient(environment.configCatKey, configcat.PollingMode.AutoPoll, {
        dataGovernance: configcat.DataGovernance.EuOnly,
        pollIntervalSeconds: 120,
      });
    }
  }

  public static getValueAsync(flag: string): Promise<boolean> {
    if (!ConfigCatService._client) {
      ConfigCatService.init();
    }
    return ConfigCatService._client.getValueAsync(flag, false);
  }

  public static useFeaturePerOrganizers$(flag: string, affId: number, organizerId: number): Observable<boolean> {
    if (!ConfigCatService._client) {
      ConfigCatService.init();
    }

    return from(ConfigCatService._client.getValueAsync<string>(flag, null)).pipe(
      map(val => {
        if (isNullOrUndefined(val)) {
          return false;
        }

        try {
          const affiliates = (JSON.parse(val) as FeaturePerOrganizers).affiliates;
          const affiliate = affiliates.find(a => a.id === affId);

          var toUse = affiliate?.organizers?.includes(organizerId) || affiliate?.allOrganizers || false;

          return toUse;
        } catch (error) {
          console.error(`Failed to parse feature '${flag}' organizers:`, error);
          return false;
        }
      }),
    );
  }

  public static useFeaturePerAffiliates$(flag: string, affId: number): Observable<boolean> {
    if (!ConfigCatService._client) {
      ConfigCatService.init();
    }

    return from(ConfigCatService._client.getValueAsync<string>(flag, null)).pipe(
      map(val => {
        if (isNullOrUndefined(val)) {
          return false;
        }

        try {
          const affiliates = (JSON.parse(val) as FeaturePerAffiliates).affiliates;

          var toUse = affiliates.includes(affId) || false;

          return toUse;
        } catch (error) {
          console.error(`Failed to parse feature '${flag}' affiliates:`, error);
          return false;
        }
      }),
    );
  }
}

interface FeaturePerOrganizers {
  affiliates: AffiliateFeature[];
}

interface FeaturePerAffiliates {
  affiliates: number[];
}

interface AffiliateFeature {
  id: number;
  organizers: number[];
  allOrganizers: boolean;
}
